import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { FileViewModalForm } from './form';
import { SimpleModal, Icon } from '@livable/saas-react-components';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FileViewModal = observer(_ref => {
  let statementToPreview = _ref.statementToPreview,
    providerInfo = _ref.providerInfo;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t('add_new_property_flow.is_this_an_account_you_are_looking_for'),
    subTitle: 'Account Id: 12134qwer123431sqwew',
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      'custom-attribute': '212-FileViewModal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('File view modal')))
  }, /*#__PURE__*/React.createElement(FileViewModalForm, null));
});